import get from 'lodash.get';

import type { DependenciesFormValues } from '../../../types/FormValues';

import type { AccordionType } from './index';

export const getDependencyOpenWhen = (
  openWhen: AccordionType['openWhen'],
  values: DependenciesFormValues,
  currentSectionKey: string
): boolean => {
  if (!openWhen || !values) return false;

  return openWhen.some((condition) => {
    const fieldValue = get(
      values,
      `${currentSectionKey}.${condition.fieldKey}`
    ) as unknown as string;
    return Object.entries(condition.conditions).every(([operator, value]) => {
      switch (operator) {
        case '$eq':
          return fieldValue === value;
        default:
          return false;
      }
    });
  });
};

export const getDependencyDisabledWhen = (
  disabledWhen: AccordionType['disabledWhen'],
  values: DependenciesFormValues,
  currentSectionKey: string
): boolean => {
  if (!disabledWhen || !values) return false;

  return disabledWhen.some((condition) => {
    const fieldValue = get(
      values,
      `${currentSectionKey}.${condition.fieldKey}`
    ) as unknown as string;
    return Object.entries(condition.conditions).every(([operator, value]) => {
      switch (operator) {
        case '$eq':
          return fieldValue === value;
        default:
          return false;
      }
    });
  });
};
